import { clsx } from 'clsx';
import React, { ReactNode } from 'react';

import { Button } from '../Button/Button';

type ActionType =
  | {
      type: 'custom';
      actionComponent: React.ComponentType<any>;
    }
  | {
      type: 'retry' | 'undo';
      onAction: () => void;
    };

type ToasterProps = {
  variant: 'success' | 'error' | 'warning' | 'info';
  message: ReactNode;
  action?: ActionType;
  closeToast: () => void;
  toastId: string | number;
  'data-testid'?: string;
};

export const ToasterContent = ({
  variant,
  message,
  action,
  closeToast,
  toastId,
  'data-testid': dataTestId,
}: ToasterProps) => {
  const getAction = () => {
    switch (action?.type) {
      case 'custom': {
        const CustomComponent = action.actionComponent;
        return <CustomComponent closeToast={closeToast} toastId={toastId} />;
      }
      case 'retry':
      case 'undo':
        return (
          <Button
            type="button"
            className="ToasterContent-actionButton"
            size="small"
            variant="tertiary"
            onClick={() => {
              action.onAction();
              closeToast();
            }}
            data-testid="undo-snack-notification-btn"
          >
            {action.type === 'undo' ? 'Undo' : 'Retry'}
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <div
      id="custom-toastify"
      className={clsx('ToasterContent', `toastify__container--${variant}`)}
      data-testid={dataTestId ?? (variant === 'success' ? 'added-snack-notification' : 'removed-snack-notification')}
    >
      <div className="ToasterContent-content">
        <div className="ToasterContent-message" id="custom-toastify__message">
          {message}
        </div>
        {getAction()}
      </div>
    </div>
  );
};
